import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type ErrorState = {
  title: string
  message: string
  showRetryButton: boolean
  showHomeButton: boolean
  timestamp: number
  isGlobal: boolean
}

export const useErrorStore = defineStore('error', () => {
  const currentError = ref<ErrorState | null>(null)

  const setError = (errorData: Partial<ErrorState>) => {
    currentError.value = {
      isGlobal: Boolean(errorData.isGlobal),
      title: errorData.title || 'Something Went Wrong',
      message:
        errorData.message ||
        'We encountered an unexpected error. Please try again or contact support if the problem persists.',
      showRetryButton: errorData.showRetryButton ?? true,
      showHomeButton: errorData.showHomeButton ?? true,
      timestamp: Date.now(),
    }
  }

  const clearError = () => {
    currentError.value = null
  }

  const hasError = computed(() => currentError.value !== null)

  return {
    currentError,
    setError,
    clearError,
    hasError,
  }
})
